// extracted by mini-css-extract-plugin
export default {"wrap":"JG-z","fullWidth":"KG-z","hideOnDesktop":"LG-z","content":"MG-z","hasOpenedNav":"NG-z","crumbsList":"OG-z","dropdownsWrap":"PG-z"};